// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XngStickyWrapper } from "@awc/App/Components/XngSticky/XngSticky";
import { myAccountDetailsPagesLayout } from "@awc/App/Widgets/Layout/MyAccountDetailsPagesLayout";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

myAccountDetailsPagesLayout.container = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: block !important;
        }
    `,
};

myAccountDetailsPagesLayout.informationContainer = {
    css: css`
        display: flex;
        gap: 16px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 24px;
        }
        @media print {
            display: block !important;
        }
    `,
};
myAccountDetailsPagesLayout.information = {
    css: css`
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        @media print {
            display: block !important;
            h2 {
                font-size: 15px;
            }
        }
    `,
};
myAccountDetailsPagesLayout.productList = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.total = {
    css: css`
        flex: 0 0 41.66%;
        &,
        & ${XngStickyWrapper} {
            display: flex;
            flex-direction: column;
            gap: 16px;
            @media print {
                display: block !important;
            }
        }
        &:has(> div:empty) {
            display: none;
        }
        @media print {
            display: block !important;
            margin-top: 25px;
            max-width: 450px;
        }
        ${xScreen("lte", "md")} {
            flex-basis: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.productLisContainer = {
    css: css`
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

myAccountDetailsPagesLayout.details = {
    css: css`
        display: flex;
        column-gap: 16px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            @media print {
                display: block !important;
            }
        }
        @media print {
            display: block;
        }
    `,
};

myAccountDetailsPagesLayout.detailsLeftColumn = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        ${xScreen("gte", "lg")} {
            & > div {
                &:empty {
                    display: none;
                }
            }
        }
        @media print {
            display: block !important;
        }
    `,
};

myAccountDetailsPagesLayout.detailsRightColumn = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        & > div {
            &:empty {
                display: none;
            }
        }
        @media print {
            display: block !important;
        }
    `,
};

myAccountDetailsPagesLayout.titleActionWrapper = {
    css: css`
        display: flex;
        gap: 16px;
        align-items: baseline;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            @media print {
                display: block !important;
            }
        }
    `,
};

myAccountDetailsPagesLayout.titleContainer = {
    css: css`
        flex-basis: 33.33%;
        flex-grow: 1;
        ${xScreen("lte", "md")} {
            flex-basis: 100%;
            width: 100%;
        }
    `,
};

myAccountDetailsPagesLayout.actionContainer = {
    css: css`
        flex-basis: 66.66%;
        &:has(> div:empty) {
            display: none;
        }
        ${xScreen("lte", "md")} {
            flex-basis: 100%;
            width: 100%;
            margin-bottom: 10px;
        }
    `,
};
